import moment from 'moment';
import api from '@/API';
import { Client, UserClient, OpenDateRange } from '@/type';
import eventBus from '@/messaging/event-bus';
import { ClientEdited, ClientDeleted, UserAssignedToClient } from '@/messaging/events';
import repository from './client-repository';

interface AddClientResult {
  client: Client,
  userClient: UserClient,
}

export function add(
  customerId: number, firstName: string, lastName: string,
  email: string, phone: string, dateOfBirth: string, dateOfLoss: string,
  star: boolean, assignTo: number[], fileRefNo?: string, paymentMethodId?: number|null,
): Promise<Client> {
  const url = `customers/${customerId}/clients`;
  const task = api.post(url, {
    customerId,
    firstName,
    lastName,
    email,
    phone,
    dateOfBirth,
    fileRefNo,
    dateOfLoss,
    paymentMethodId,
    star,
    assignTo,
  });
  return task.then((response) => {
    const result = (response.data as AddClientResult);
    eventBus.$emit(UserAssignedToClient.eventName, new UserAssignedToClient(
      result.userClient,
    ));
    return result.client;
  });
}

export function edit(client: Client): Promise<void> {
  const url = `clients/${client.id}`;
  return api
    .put(url, client)
    .then(() => {
      eventBus.$emit(ClientEdited.eventName, new ClientEdited(client));
    });
}

export function deleteClient(id: number): Promise<void> {
  return api
    .delete(`clients/${id}`)
    .then(() => {
      eventBus.$emit(ClientDeleted.eventName, new ClientDeleted(id));
    });
}

export function getPreLossRange(dateOfLoss: string): OpenDateRange {
  const dayBeforeLoss = moment(dateOfLoss).subtract(1, 'd');
  return {
    end: dayBeforeLoss.format('YYYY-MM-DD'),
  };
}

export function getPostLossRange(dateOfLoss: string): OpenDateRange {
  return {
    start: dateOfLoss,
  };
}

export function isPreLossRange(dateOfLoss: string, range: OpenDateRange): boolean {
  const preLossRange = getPreLossRange(dateOfLoss);
  return (!range.start && range.end === preLossRange.end);
}

export function isPostLossRange(dateOfLoss: string, range: OpenDateRange): boolean {
  return (!range.end && range.start === dateOfLoss);
}

export function isPreLoss(dateOfLoss: string, date: string): boolean {
  const dateLoss = moment(dateOfLoss);
  const d = moment(date);
  return d.isBefore(dateLoss);
}

export function isPostLoss(dateOfLoss: string, date: string): boolean {
  const dateLoss = moment(dateOfLoss);
  const d = moment(date);
  return d.isSameOrAfter(dateLoss);
}
